module.exports = __webpack_public_path__ + "static/media/fullstack.589bec7d.svg";